<div class="inner-message" *ngIf="appService.inlineSuccessMessage || appService.inlineErrorMessage">
    <div class="inner-message-success" *ngIf="appService.inlineSuccessMessage">
        <span class="inner-message-success-icon">
            <img class="dhl-input-error-icon" src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1900,24,24))">
        </span>
        <span class="inner-message-success-text">
            {{ appService.inlineSuccessMessage | translate }}
        </span>
    </div>
    <div class="inner-message-error" *ngIf="appService.inlineErrorMessage">
        <span class="inner-message-error-icon">
            <img class="dhl-input-error-icon" src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
        </span>
        <span class="inner-message-error-text">
            {{ appService.inlineErrorMessage | translate }}
        </span>
    </div>
</div>